import React from 'react';
import styles from './LoadingSpinner.module.css'; // Подключите CSS для стилизации спиннера

const LoadingSpinner = () => {
    return <div className={styles.spinner}></div>;
};

export default LoadingSpinner;
